export default function EquationRootTail() {
  return (
    <svg
      preserveAspectRatio="xMaxYMax slice"
      height="43"
      viewBox="0 0 296 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 100 2 L 100 2H 294.5 V 15.2759" stroke="#D4D7E2" strokeWidth="3" />
    </svg>
  )
}
